import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { recognizeItems } from '../data/piano';
export function Recognize() {
  return <section className="w-full bg-slate-900 px-8 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-265" data-mp="30xq63faromvb">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12" data-id="element-266" data-mp="2w56rqg499npg">
        <div className="self-start lg:sticky lg:top-24 lg:col-span-5" data-id="element-267" data-mp="2r7ww2iq9wft6">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-268" data-mp="2r5kck14v9xe0">
            Have you ever felt this way?
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-269" data-mp="2i5nnvzih8yiy">
            If you answer yes to even one of these, PIANO READY™ is for you.
          </p>
          <a href="#inside" className="group mt-10 inline-flex items-center gap-2 font-serif text-2xl italic text-red-300 transition-colors duration-150 ease-out hover:text-stone-50" data-id="element-270" data-mp="2892fd47915ad">
            You deserve an easier way
            <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-271" data-mp="6i7isa57x22l" />
          </a>
        </div>

        <ul className="divide-y divide-white/10 border-y border-white/10 lg:col-span-7" data-id="element-272" data-mp="3nmfdvjz43h0r">
          {recognizeItems.map(item => {
          const Icon = item.icon;
          return <li key={item.title} className="flex gap-5 py-7 sm:gap-6" data-id="element-273" data-mp="39p0ky59ngr41">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/15 text-red-300" data-id="element-274" data-mp="3emsdn1i4ch9a">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-275" data-mp="68jqwa2a2kp1" />
                </span>
                <div data-id="element-276" data-mp="b7d21vu3dzm1">
                  <h3 className="font-serif text-2xl leading-tight sm:text-3xl" data-id="element-277" data-mp="3sls2a95msw5g">{item.title}</h3>
                  <p className="mt-2 leading-relaxed text-stone-50/70" data-id="element-278" data-mp="1fh3yks0a9ht">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}